import React from "react";
import RightArrowIcon from "images/arrow-right-black.svg";
import GradientButton from "@tomocredit/common-fe/components/common/GradientButton";

export const ActionCard = ({
  title = "",
  subtitle = "",
  paragraph = "",
  imageClass = "",
  heroImage,
  heroImageMobile,
  ctaText = "",
  reversed = false,
  isMobile = false,
  onClickButton = () => {},
  onClickCard = () => {},
  belowMd,
}) => {

  return(
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      data-testid="iq-landing-action-card"
      className={`flex flex-col-reverse ${reversed ? "md:flex-row-reverse" : "md:flex-row"} justify-between items-center max-w-page m-4 md:m-auto gap-10 md:gap-6 p-6 md:p-0 rounded-xl`}
      style={{ background: belowMd ? "rgba(255, 255, 255, 0.08)" : undefined }}
      onClick={onClickCard}
    >
      <div className="flex flex-col flex-1 md:py-20 md:px-12" style={{ letterSpacing: "0.1px" }}>
        {title &&
          <span className="text-[28px] font-bold leading-tight" style={{ letterSpacing: "-0.25px" }}>{title}</span>
        }
        {subtitle &&
          <p className="mt-4 text-lg font-bold leading-normal">{subtitle}</p>
        }
        {paragraph &&
          <p className="text-lg font-medium leading-normal">{paragraph}</p>
        }
        {ctaText &&
          <GradientButton
            color="black" marginTop="16px" className="ignore"
            clickMethod={onClickButton}
          >
            <span className="flex flex-row ignore text-lg">{ctaText} <img alt="" src={RightArrowIcon} /></span>
          </GradientButton>
        }
      </div>
      <div className="flex-1 grid place-items-center flex-grow">
        <img alt="" src={isMobile ? heroImageMobile : heroImage} className={imageClass} />
      </div>
    </div>
  );
};
